export type Placement = 'bottom' | 'bottom-start' | 'bottom-end' | 'left' | 'top' | 'top-start' | 'right';

export function placementToCSSProperty(placement: Placement) {
  const staticSide = {
    'top': 'bottom',
    'right': 'left',
    'bottom': 'top',
    'left': 'right',
    'bottom-end': 'top',
    'bottom-start': 'top',
    'top-start': 'bottom',
  }[placement];

  return staticSide;
}
